import { SidebarDesign } from '@/types/sidebar';
import { APP_CONFIG } from '@/config/app.config';

/**
 * Navigation Configuration for Sidebar
 *
 * Items are tagged with a `section` field. In expanded mode the sidebar
 * regroups items by that field, rendering a caption-style header per section.
 * In collapsed mode section headers are hidden and items render as icons.
 *
 * Sections:
 * - PLATFORM: core product surfaces (Templates, Sites, Domains)
 * - ACCOUNT:  user/org settings (Profile, Settings, Billing, Pricing)
 */

export const navigationConfig: Partial<SidebarDesign> = {
  navigation: {
    sections: [
      {
        items: [
          {
            label: 'Sites',
            href: '/sites',
            icon: 'LayoutGrid',
            permission: 'read:sites'
          },
          {
            label: 'Templates',
            href: '/templates',
            icon: 'LayoutPanelLeft'
          },
          {
            label: 'Domains',
            href: '/domains',
            icon: 'Globe',
            permission: 'read:domains'
          },
          {
            label: 'Invites',
            href: '/invites',
            icon: 'UserPlus',
            permission: 'create:invitations'
          }
        ]
      }
    ],
    userMenu: {
      trigger: 'avatar',
      items: [
        { label: 'Profile',  href: '/profile',  icon: 'User' },
        { label: 'Settings', href: '/settings', icon: 'Settings' },
        { label: 'Billing',  href: '/billing',  icon: 'CreditCard' },
        { label: 'Pricing',  href: '/pricing',  icon: 'DollarSign' },
        { type: 'separator' },
        { label: 'Logout', action: 'logout', icon: 'LogOut' }
      ],
      showUserInfo: true
    },
    branding: {
      logo: '/landing-logo.svg',
      title: APP_CONFIG.APP_NAME,
      href: '/',
      showOnCollapse: true
    }
  },
  layout: {
    mobile: 'overlay',
    desktop: 'collapsible',
    breakpoints: {
      mobile: '640px',
      tablet: '768px',
      desktop: '1024px'
    },
    defaultCollapsed: false,
    collapsedWidth: '4.5rem',
    expandedWidth: '12rem'
  },
  theme: {
    variant: 'default',
    colorScheme: 'system',
    borderRadius: 'md'
  }
};

export default navigationConfig;
